import {componentLoader, componentConfig} from "../../lib/component_initializer";
import {ModalizerConfig, Modalizer} from "./modalizer"

export const modalizerLoader = function(options={}){
    componentLoader(componentConfig(Modalizer, ModalizerConfig.componentTypeKey, ModalizerConfig.baseHtmlClass), options);
};

